import React from 'react';

export const SortAscending: React.FC<React.SVGProps<SVGSVGElement>> = ({ width, height, color }) => (
    <svg viewBox='0 0 256 256' width={width || '1em'} height={height || '1em'}>
        <polyline strokeWidth='16' strokeLinejoin='round' strokeLinecap='round' stroke={color || 'currentColor'} points='96,79.99999940395355 128,47.99999940395355 160,79.99999940395355 ' fill='none' />
        <line y2='48' y1='208' x2='127.999996' x1='127.999996' strokeWidth='16' strokeLinejoin='round' strokeLinecap='round' stroke={color || 'currentColor'} fill='none' />
    </svg>
);
